<template>
  <b-form-group
    label="Proforma Tarihi"
    label-for="pdate"
  >
    <validation-provider
      #default="{ errors }"
      name="Proforma Tarihi"
      rules="required"
    >
      <b-form-datepicker
        id="pdate"
        v-model="dataItem.pdate"
        v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
        locale="tr"
        start-weekday="1"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormDatepicker } from 'bootstrap-vue'
import { ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'ProformaDate',
  components: {
    BFormGroup,
    BFormDatepicker,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['proformaInvoices/dataItem']
    },
  },
  created() {
    localize('tr')
  },
  mounted() {
    this.setProformaDate()
  },
  methods: {
    setProformaDate() {
      if (!this.dataItem.pdate) {
        this.dataItem.pdate = this.moment().format('YYYY-MM-DD')
      }
    },
  },
}
</script>
